import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { AuthFeature, OidcSecurityService, PassedInitialConfig, provideAuth } from 'angular-auth-oidc-client';
import { tap } from 'rxjs';

export function provideAuthentication(
    config: PassedInitialConfig,
    ...features: AuthFeature[]
): (Provider | EnvironmentProviders)[] {
    return [
        provideAuth(config, ...features),
        provideAppInitializer(() => {
            const authenticationService = inject(AuthenticationService);
            const oidcSecurityService = inject(OidcSecurityService);

            authenticationService.isAuthenticating.set(true);

            return oidcSecurityService.checkAuth().pipe(
                tap(({ isAuthenticated }) => {
                    if (isAuthenticated) {
                        authenticationService.isAuthenticating.set(false);
                    } else {
                        oidcSecurityService.authorize();
                    }
                })
            );
        })
    ];
}
